"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const controlIsLegacy_1 = __importDefault(require("../../shared/controlIsLegacy"));
const flatControlsArray_1 = __importDefault(require("./flatControlsArray"));
const defaultPath = [];
const flatControl = ({ control, parentControlId, initialObject, path = defaultPath, context, }) => {
    if (!(0, controlIsLegacy_1.default)(control)) {
        return initialObject;
    }
    const controlDef = {
        control,
        path,
        context,
    };
    if (parentControlId) {
        controlDef.parentControlId = parentControlId;
    }
    return (0, flatControlsArray_1.default)({
        controls: control.controls,
        parentControlId: control.id,
        initialObject: Object.assign(Object.assign({}, initialObject), { [control.id]: controlDef }),
        path,
        context,
    });
};
exports.default = flatControl;
